import { useEffect, useMemo, useRef } from 'react';
import { useAppDispatch } from '@wappsto/redux';
import equal from 'deep-equal';
import { updateStream } from '../util';

export default function useSubscribe(type: string, ids: string | string[] | undefined): void {
  const dispatch = useAppDispatch();
  const cached = useRef<string[] | undefined>([]);
  const arr = useMemo(() => {
    let data: string[] | undefined;
    if (ids) {
      if ((ids as any).constructor === Array) {
        data = (ids as string[]).map((id) => `/${type}/${id}`);
      } else {
        data = [`/${type}/${ids}`];
      }
    }
    if (!equal(data, cached.current)) {
      cached.current = data;
    }
    return cached.current;
  }, [type, ids]);

  useEffect(() => {
    if (arr) {
      updateStream(dispatch, arr, 'add');
    }
    return () => {
      if (arr) {
        updateStream(dispatch, arr, 'remove');
      }
    };
  }, [arr, dispatch]);
}
